import { getValueFromCurrentUrl } from '../../qaamgo/helper/query-fragment-params';
import { globalLogger } from '../../qaamgo/helper/global-logger';
import { testIsArray, testIsNonEmptyString, testIsObject } from '../../lib/test-and-assert/test-base';
import { gapiClientDriveExists } from '../../qaamgo/helper/gapi';

function showGenericError() {
    $('#somethingWentWrongAlert').removeClass('hidden');

    $('.consent-header').addClass('hidden');
    $('.feature-title').addClass('hidden');
    $('.file-info-container').addClass('hidden');
    $('.loading').addClass('hidden');
    $('.tile-container').addClass('hidden');
}

let clientId = null;
let appId = null;
let developerKey = null;

let files = null;
let userId = null;

let authSuccess = false;
let authTried = false;

let tokenClient;
let _oauthToken = null;

const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';

function onApiLoad() {
    window.gapi.load('client', initClient);
}

function initClient() {
    gapi.client.init({
        apiKey: developerKey,
        discoveryDocs: [DISCOVERY_DOC],
    });

    tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope: 'https://www.googleapis.com/auth/drive.file',
        include_granted_scopes: false,
    });

    onAuthApiLoad();
}

function onAuthApiLoad() {

    // Request an access token.
    tokenClient.callback = async (response) => {
        if (response.error !== undefined) {
            throw (response);
        }
        _oauthToken = response.access_token;
        handleAuthResult();
    };

    if (_oauthToken === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({prompt: 'consent'});
    } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({prompt: ''});
    }
}

function handleAuthResult() {
    $('.loading').hide();

        authSuccess = true;
        $('.consent-header').addClass('hidden');
        $('.tile-container').show();
        $('.file-info-container').removeClass('hidden');
        getFileMetadata(files[0], _oauthToken);
}

function getFileMetadata(fileId, token) {
    if (!gapiClientDriveExists()) {
        setTimeout(function () {
            getFileMetadata(fileId, token);
        }, 500);

        return;
    }

    const request = gapi.client.drive.files.get({
        fileId: fileId,
    });

    request.execute(function (resp) {
        const d = {
            name: resp.name,
            token: token,
            fileid: fileId,
            mimetype: resp.mimeType,
        };

        const s = JSON.stringify([d]);

        const queryString = 'gdrive_files=' + encodeURIComponent(s);

        $('#cloud-file').text('Google Drive: ' + resp.name);

        $('.one-click-convert-btn').removeClass('disabled');

        $(document).on('click', '.one-click-convert-btn', function (e) {
            e.stopPropagation();
            e.preventDefault();

            const featureLink = $(this).data('link');

            window.location = `${featureLink}#${queryString}`;
        });
    });
}

import(
    /* webpackMode: "eager" */
    '../qg-main'
).then(function () {

    if (sessionStorage.getItem('PLAYWRIGHT') === 'true') {
        return;
    }

    clientId = window.gDriveUIData.clientId;
    appId = window.gDriveUIData.appId;
    developerKey = window.gDriveUIData.developerKey;

    const state = getValueFromCurrentUrl('state');

    if (!testIsNonEmptyString(state)) {
        globalLogger.log('cloud ui - fail - no state parameter');

        showGenericError();

        return;
    }

    $('.tile-container').hide();

    let googleData = null;

    try {
        googleData = JSON.parse(state);
    } catch (e) {}

    if (!testIsObject(googleData)) {
        globalLogger.log('cloud ui - fail - could not parse gdrive data');

        showGenericError();

        return;
    }

    if (!testIsNonEmptyString(googleData['userId']) || !testIsArray(googleData['ids'])) {
        globalLogger.log('cloud ui - fail - invalid gdrive data', state);

        showGenericError();

        return;
    }

    files = [googleData['ids'][0]];
    userId = googleData['userId'];

    $.when(
        $.cachedScript('https://apis.google.com/js/api.js'),
        $.cachedScript('https://accounts.google.com/gsi/client')
    ).done(function() {
        onApiLoad();
    });
});
